module.exports = __webpack_public_path__ + "img/reward-success-dark.90b848f4.png";